import { axios } from "../../../lib/axios";
import { schedulingPost } from "./client";

export const notificationSettings = (organizationRef) => axios.get("scheduling/notifications/settings", { params: { organizationRef } });
export const appointmentNotificationChannels = (organizationRef) => axios.get("scheduling/notifications/channels", { params: { organizationRef } });
export const saveNotificationSetting = (organizationRef, setting) => axios.put("scheduling/notifications/settings", { organizationRef, ...setting });
export const resetNotificationSetting = (organizationRef, setting) => axios.delete("scheduling/notifications/settings", { params: { organizationRef, eventType: setting.eventType, audience: setting.audience, version: setting.version } });
export const schedulingNotifications = (organizationRef, cursor) => axios.get("scheduling/notifications", { params: { organizationRef, ...(cursor ? { cursor } : {}) } });
export const markSchedulingNotificationRead = (organizationRef, notificationId) => axios.put("scheduling/notifications/read", { organizationRef, notificationId });
export const requestAppointmentReschedule = (input) => schedulingPost("appointment/request-reschedule", input);

export const isSchedulingAppointmentTopic = topic => /^appt-[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(topic || "");

export function schedulingSessionContext(encounter) {
  return /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(encounter?.appointmentId || "") && encounter?.orgId && encounter?.id
    ? { appointmentId: encounter.appointmentId, organizationRef: encounter.orgId, encounterId: encounter.id } : null;
}
export function notifyAppointmentSessionReady(encounter) {
  const context = schedulingSessionContext(encounter);
  return context ? axios.post("scheduling/appointment/session-ready", context) : Promise.resolve();
}
export function inviteSchedulingGuest(encounter, email) {
  const context = schedulingSessionContext(encounter);
  if (!context) return Promise.reject(new Error("Appointment session is unavailable"));
  return axios.post("scheduling/appointment/invite", { ...context, email });
}
